import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import store from '../../store/store'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import router from '../../router'
import refreshAuthLogic from '../auth/refresh'

// Axios Configuration
Vue.use(VueAxios, axios)

function setupInterceptors (vueApp) {
  createAuthRefreshInterceptor(Vue.axios, refreshAuthLogic)
  Vue.axios.defaults.baseURL = process.env.API_URL
  Vue.axios.interceptors.request
    .use(config => {
      if (config.url.includes('/admin') || config.url.includes('/users')) {
        config.headers['Cache-Control'] = 'no-cache, no-store'
        config.headers['Pragma'] = 'no-cache'
        config.headers['Expires'] = '0'
      }
      let token = store.getters.idToken
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
      vueApp.$Progress.start()
      return config
    }, error => {
      vueApp.$Progress.fail()
      return error
    })
  Vue.axios.interceptors.response
    .use(config => {
      vueApp.$Progress.finish()
      return config
    }, error => {
      vueApp.$Progress.fail()
      if (error.response && error.response.status === 401 && router.currentRoute.path !== '/sign_in') {
        Vue.toasted.clear()
        Vue.toasted.show('Session expired, please login to continue', { icon: 'chain-broken', type: 'error', singleton: true })
        store.dispatch('logOut')
        console.log('sing in route')
        router.replace(`/sign_in?redirect_to=${encodeURIComponent(router.currentRoute.fullPath)}`)
      }
      return Promise.reject(error.response)
    })
}

export default setupInterceptors



// WEBPACK FOOTER //
// ./src/services/api/interceptors.js